var map = {
	"./2020.png": 21,
	"./404-adna.png": 36,
	"./CAFFEINE.png": 93,
	"./behavior.png": 94,
	"./behavior_exercise.png": 95,
	"./behavior_sleep.png": 96,
	"./behavior_snacking.png": 97,
	"./body.png": 98,
	"./body_adiposity.png": 99,
	"./body_foodcravings.png": 100,
	"./body_imc.png": 101,
	"./body_insulin.png": 102,
	"./body_ldl.png": 103,
	"./body_steatosis.png": 104,
	"./body_triglycerides.png": 105,
	"./body_weightloss.png": 106,
	"./body_weightregain.png": 107,
	"./body_whr.png": 108,
	"./cerba-int.png": 109,
	"./cerba.png": 110,
	"./cmed.png": 111,
	"./dnyou.png": 112,
	"./flag_DE.png": 37,
	"./flag_EN.png": 38,
	"./flag_ES-ES.png": 39,
	"./flag_FR-FR.png": 40,
	"./flag_IT-IT.png": 41,
	"./flag_PT-BR.png": 42,
	"./flag_PT-PT.png": 43,
	"./food.png": 113,
	"./food_caffeine.png": 114,
	"./food_carbs.png": 115,
	"./food_complexcarbs.png": 116,
	"./food_fat.png": 117,
	"./food_fiber.png": 118,
	"./food_gluten.png": 119,
	"./food_lactose.png": 120,
	"./food_mufa.png": 121,
	"./food_protein.png": 122,
	"./food_pufa.png": 123,
	"./food_restriction.png": 124,
	"./food_salt.png": 125,
	"./food_vitamins.png": 126,
	"./healthylab.png": 127,
	"./heartcolor.png": 22,
	"./hg-heart-logo.png": 128,
	"./hg.png": 35,
	"./invenimus.png": 129,
	"./iproprium.png": 130,
	"./nimgenetics.png": 131,
	"./pathotrier.png": 132,
	"./unilabs.png": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;